import axios from "axios";

export const url =
  import.meta.env.MODE === "development"
    ? "http://localhost:3379"
    : "https://bcrx-api.careapps.net";

const instance = axios.create({
  baseURL: url,
  //baseURL: "https://7df7-102-90-65-195.ngrok-free.app",
});

export default instance;

export const frontUrl =
  import.meta.env.MODE === "development"
    ? "http://localhost:5173"
    : "https://prescriber.careapps.net";

export const facUrl = (facility) =>
  import.meta.env.MODE === "development"
    ? `http://localhost:3000/${facility.name}/${facility.id}`
    : `https://forassure.com/${facility.name}/${facility.id}`;
